var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMascotVault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 328,
    height: 124,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE767",
    d: "M89.743 54.457c1.167-8.661 7.944-9.022 11.187-8.12 1.459 7.398 3.21 22.087-1.46 21.654-5.836-.542-11.186-2.707-9.727-13.534Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M103.25 36c2-3.2 7.833-2 10.5-1l19.5 32c-8.167 9-26.1 23.6-32.5 10-8-17 0-37 2.5-41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3160",
    fillRule: "evenodd",
    d: "M100.544 76.554c-5.388-17.672 2.011-36.835 5.011-42.27 2.599-.854 6.244-.015 8.195.716l19.095 31.337.352.72c-8.19 9.005-26.061 23.514-32.447 9.943-.07-.148-.139-.297-.206-.446Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C91941",
    fillRule: "evenodd",
    d: "M112.511 34.594a3.921 3.921 0 0 0-.875.95c-2.706 4.128-11.743 24.984-4.643 43.44.563 1.462 1.253 2.636 2.047 3.555 7.983-.189 18.491-9.237 24.21-15.539l-19.5-32c-.361-.135-.78-.274-1.239-.406Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3160",
    d: "M137.75 123.5c-2-.4-2.5-12.833-2.5-19l15.5 6c-3.5 4.5-11 13.4-13 13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E32752",
    d: "M194.25 124c-2.8.8-8.167-9-10.5-14l13-3c.333 5.333.3 16.2-2.5 17Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.25,
    cy: 59.5,
    fill: "url(#b)",
    rx: 62.5,
    ry: 58.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFED8A",
    fillRule: "evenodd",
    d: "M146.807 114.115c-19.674-9.852-33.057-29.27-33.057-51.615 0-32.309 27.982-58.5 62.5-58.5 7.91 0 15.476 1.375 22.442 3.885C189.919 3.49 179.895 1 169.25 1c-34.518 0-62.5 26.191-62.5 58.5 0 24.905 16.626 46.175 40.057 54.615Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M167.519 25.243c-2.874 9.333-3.615 18.72-3.538 24.832 9.002 2.695 21.84 3.167 32.678 2.925a260.547 260.547 0 0 0 14.158-.715 224.67 224.67 0 0 0 5.399-.485l.296-.031.074-.008.018-.003h.006l.14 1.242.139 1.242h-.002l-.005.001-.02.002-.079.009-.306.033a228.628 228.628 0 0 1-5.466.49c-3.634.283-8.674.597-14.296.723-11.193.25-24.882-.24-34.351-3.31a1.25 1.25 0 0 1-.864-1.156c-.169-6.27.515-16.41 3.63-26.527 2.553-8.29 6.772-16.664 13.584-22.84 1.082.153 2.154.333 3.217.538-7.262 5.85-11.74 14.362-14.412 23.038ZM142.499 50.966c-.163-6.038.746-15.89 4.012-25.696 3.038-9.122 8.072-18.075 16.048-23.939a66.427 66.427 0 0 0-4.702.639c-6.68 6.136-11.004 14.36-13.718 22.51-3.155 9.472-4.18 18.974-4.158 25.313-9.295.264-16.517-.78-21.781-2.2-4.485-1.21-7.5-2.677-9.171-3.804a55.124 55.124 0 0 0-.686 2.527c2.034 1.233 5.102 2.584 9.206 3.691 5.758 1.552 13.635 2.647 23.751 2.242a1.25 1.25 0 0 0 1.199-1.283Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.249,
    cy: 50.5,
    fill: "#000",
    rx: 10.5,
    ry: 24.5,
    transform: "rotate(2.31 125.249 50.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M115.347 60.622c-.521-3.21-.741-6.786-.589-10.545.143-3.534.599-6.88 1.299-9.892A7.798 7.798 0 0 1 117.75 40c4.97 0 9 4.701 9 10.5s-4.03 10.5-9 10.5a7.808 7.808 0 0 1-2.403-.378Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M122.183 41.36c2.727 1.804 4.567 5.221 4.567 9.14 0 .165-.004.33-.01.493-2.917-.16-5.24-3.006-5.24-6.493 0-1.139.248-2.209.683-3.14Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.249,
    cy: 24.503,
    fill: "#000",
    rx: 11.249,
    ry: 24.503,
    transform: "matrix(.9993 .0376 -.04316 .99907 171.245 27)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M170.751 61.633c-.51-3.107-.72-6.546-.564-10.153.16-3.71.691-7.214 1.506-10.34a8.665 8.665 0 0 1 1.556-.14c5.247 0 9.5 4.701 9.5 10.5s-4.253 10.5-9.5 10.5a8.664 8.664 0 0 1-2.498-.367Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M177.572 42.147c3.074 1.74 5.178 5.275 5.178 9.353 0 .506-.033 1.004-.095 1.49-3.43-.193-6.155-3.249-6.155-6.99 0-1.423.395-2.748 1.072-3.853Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M146.25 58c0 4 5.25 7 8.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M155.25 16.5c1.6-.4 2 1.167 2 2 .5-1 1.9-2.7 3.5-1.5 2 1.5-3 5.5-4.5 5.5s-3-5.5-1-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3160",
    d: "M211.75 60c-1.2-17.2 3.999-24.77 8-26 6.5-2 26.051-6 26.5 20.5.5 29.5-8 29-16.5 29.5s-16.5-2.5-18-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M211.75 60c-1.2-17.2 3.999-24.77 8-26 6.5-2 26.051-6 26.5 20.5.5 29.5-8 29-16.5 29.5s-16.5-2.5-18-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE767",
    d: "M235.75 59c0-6 2.5-10.5 5-10 2 .4 5.5.7 7.5 1.5 2.5 1 5.5 4.5 4.5 12s-7 7.5-11 7.5-6-3.5-6-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillRule: "evenodd",
    d: "M240.75 49c-2.5-.5-5 4-5 10 0 7.5 2 11 6 11 1.333 0 2.89 0 4.409-.278-1.582-1.847-2.659-5.508-2.659-9.722 0-4.464 1.209-8.307 2.946-10.032-1.112-.25-2.358-.437-3.498-.608-.817-.122-1.58-.236-2.198-.36Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M231.567 77.908c.16.176.429-.03.313-.236-3.039-5.383-5.278-12.11-4.946-21.24-.202-7.009 1.123-11.849 3.633-16.891.106-.212-.167-.397-.317-.214-3.684 4.511-5.824 9.655-5.607 17.2-.392 10.805 2.744 16.794 6.924 21.381Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M103 96c1.667 4.667 7.3 14.8 16.5 18M101.16 109.371c1.34 2.129 5.771 7.109 10.34 8.129M253.203 34.188c.144-5.067-8.057-14.538-18.459-13.107"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D095D",
    d: "M61.352 49.5C61.35 68.296 47.835 83.528 31.17 83.525 14.503 83.521.995 68.283.999 49.49c.003-18.794 13.516-34.026 30.183-34.023 16.666.003 30.174 15.241 30.17 34.035Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M58.277 49.021c-.004 18.53-12.829 33.547-28.646 33.544C13.814 82.564.995 67.54.998 49.01c.004-18.53 12.83-33.547 28.646-33.544 15.817.003 28.637 15.026 28.633 33.555Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m11.932 60.906 16.106-35.693c1.072.69 4.62 2.915 10.24 6.281 7.026 4.208 6.734 11.755 5.117 15.799-1.294 3.235-3.89 5.093-5.026 5.618 2.514 3.625 1.194 9.464.22 11.93-3.5 7.386-10.08 6.243-12.934 4.747l-13.723-8.682Zm17.592-17.83 2.626-5.819c.582-1.29 2.459-1.146 2.837.218l1.262 4.545a1.513 1.513 0 0 1-.986 1.843l-3.888 1.275c-1.25.41-2.392-.862-1.851-2.061Zm1.9 11.426-3.304 7.323c-.57 1.263-2.395 1.16-2.82-.158l-1.66-5.157c-.239-.74.122-1.54.835-1.85l4.965-2.167c1.27-.554 2.554.747 1.984 2.01Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D095D",
    d: "M315.849 65.953c10.311 7.415 13.338 20.84 6.762 29.983s-20.266 10.544-30.576 3.128c-10.311-7.415-13.339-20.839-6.763-29.982 6.577-9.144 20.266-10.545 30.577-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M316.373 65.451c10.165 7.311 13.347 20.273 7.106 28.95-6.241 8.678-19.541 9.786-29.707 2.474-10.166-7.31-13.347-20.272-7.106-28.95 6.241-8.677 19.541-9.785 29.707-2.474Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M304.612 95.569 291.381 72.65c.802-.315 3.422-1.385 7.486-3.14 5.08-2.196 9.106.942 10.687 3.424 1.264 1.986 1.26 4.144 1.1 4.974 2.981.05 5.664 3.078 6.633 4.585 2.672 4.834-.552 7.994-2.498 8.97l-10.177 4.105Zm-2.843-16.686-2.158-3.736c-.478-.829.341-1.802 1.239-1.472l2.992 1.1c.513.19.787.748.622 1.27l-.835 2.635c-.268.848-1.416.973-1.86.203Zm7.019 3.464 2.714 4.702c.468.81-.308 1.772-1.199 1.485l-3.485-1.123a1.024 1.024 0 0 1-.686-1.189l.77-3.578c.197-.915 1.418-1.107 1.886-.297Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 106.5,
    x2: 204,
    y1: 1,
    y2: 113.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#FFDE2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 241.098,
    x2: 241.098,
    y1: 48.962,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 13.213,
    x2: 68.125,
    y1: 13.849,
    y2: 74.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#6D5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E86EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#FFD66E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 279.297,
    x2: 334.252,
    y1: 76.303,
    y2: 70.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#6D5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E86EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#FFD66E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.49997 30.99997 -20.87798 .33673 241.5 64.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C91941"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C91941",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h328v124H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotVault);
export default __webpack_public_path__ + "static/media/mascot-vault.1230fb4a.svg";
export { ForwardRef as ReactComponent };